"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadTranslations = void 0;
var _adapters = require("./adapters");
var _slice = require("./slice");
var _api = require("../../../api");
var _response = require("../../../utils/response");
var _constants = require("../../../utils/constants");
const loadTranslations = brandId => async dispatch => {
  const {
    actions: {
      startLoading,
      loadSuccess,
      loadFailure
    }
  } = _slice.translationsSlice;
  if (process.env.NODE_ENV === _constants.NODE_ENV.test) {
    dispatch(loadSuccess({}));
    return;
  }
  dispatch(startLoading());
  const [sharedError, sharedData] = await (0, _api.fetchSharedTranslations)();
  const [brandError, brandData] = await (0, _api.fetchBrandTranslations)(brandId);
  const error = sharedError || brandError;
  if (error) {
    const errorMessage = (0, _response.getErrorMessage)(error);
    dispatch(loadFailure(errorMessage));
    return;
  }
  const apiTranslations = [...sharedData, ...brandData];
  const adaptedTranslations = (0, _adapters.adaptTranslations)(apiTranslations);
  dispatch(loadSuccess(adaptedTranslations));
};
exports.loadTranslations = loadTranslations;